import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import NotificationComponent from "./components/pages/administration/notificationComponent";

import SignUpComponent from "./components/Auth/signup/components/signUpComponent";
import gfComponent from "./components/Auth/signup/components/gfComponent";
import verifyEmailComponent from "./components/Auth/signup/components/verifyEmailComponent";
import verificationEmail from "./components/Auth/signup/components/signupVerification";
import RegisterComponent from "./components/pages/register/components/registerComponent";
import LoginComponent from "./components/Auth/login/login.component";
import MFAPage from "./components/Auth/login/mfaComponent";
import MfaVerification from "./components/Auth/login/mfaVerificationComponent";
import MfaVerifyotp from "./components/Auth/login/mfaOtpComponent";
import WatchRequestPage from "./components/pages/dashboard/component/Watchrequestpage";
import WatchRequestList from "./components/pages/dashboard/component/RequestlistPage";
// import ForgotPasswordComponent from "./components/Auth/forgot-password/components/forgotPasswordComponent";
import RecoveryPasswordComponent from "./components/Auth/forgot-password/components/recoveryPassvordComponent";
import ForgetSuccessComponent from "./components/Auth/forgot-password/components/forgetSuccessComponent";
import OtpPasswordComponent from "./components/Auth/forgot-password/components/otpComponent";
import verifyOtpPasswordComponent from "./components/Auth/forgot-password/components/otpComponent";
import resetPassword from "./components/Auth/forgot-password/components/resetPasswordComponent";
import IndexComponent from "./components/pages/home/components/indexComponent";
import WhoAreMainPageComponent from "./components/pages/who-we-are/components/whoWeAreMainPageComponent";
import PrivacyPolicyComponent from "./common/components/privacyPolicyComponent";
import TermsConditionComponent from './common/components/termsConditionComponent';
import FAQComponent from './common/components/faqComponent';
import GiveAwayComponent from './common/components/giveAwayComponent';
import ServiceAgreementComponent from './common/components/serviceAgreementComponent';
import Layout from './Layout'
import PricingContent from "./components/pages/dealer/components/pricingComponent";
import registerComponent from "./components/Auth/register/components/registerComponent";
import setPasswordComponent from "./components/Auth/forgot-password/components/setPasswordComponent";
import StepperComponent from "./components/pages/dealer/components/stepperComponent";
import Dealerfeed from "./components/pages/administration/dealerComponent";
import dealerInventory from "./components/pages/dashboard/component/DealerFeed/dealerInventory";
import ShopifySuccess from "./components/pages/dashboard/component/ShopifySuccess";
import ShopifyConfigPage from "./components/pages/dashboard/component/ShopifyConfigPage";
import EbaySuccess from "./components/pages/dashboard/component/EbaySuccess";
import qboSuccess from "./components/pages/dashboard/component/qboSuccess";
import AppInstall from "./components/pages/dashboard/component/appInstall";
import emailVerify from "./components/Auth/signup/components/emailVerification"
import NewStepperComponent from './components/pages/dealer/components/dealerNewsubs/dealerNewSteppper'
import chooseSubscription from "./components/pages/dealer/components/dealerNewsubs/chooseSubscription";
import inventoryTransfer from "./components/pages/dashboard/component/inventoryTransferComponent";

const theme = createMuiTheme({
  palette: {
    type: "light",
  },
});


const Routes = (
  <MuiThemeProvider theme={theme}>
    <Switch>
      {/* <Route exact={true} from="/" component={IndexComponent} /> */}
       <Route path='/' exact={true}  >
         {
          () => {
            window.location.href = "https://www.watchops.com/";
            return null;
          }
        }
      </Route> 
      <Route exact={true} from="/home" component={IndexComponent} />
      <Route exact={true} path="/sign-up" component={SignUpComponent} />
      <Route exact={true} path="/register" component={RegisterComponent} />
      <Route exact={true} path="/login" component={LoginComponent} />
      <Route exact={true} path="/mfa" component={MFAPage} />
      <Route exact={true} path="/mfa-verification" component={MfaVerification} />
      <Route exact={true} path="/mfa-otp-verify" component={MfaVerifyotp} />
      <Route exact={true} path="/watch-request" component={WatchRequestPage} />
      <Route exact={true} path="/watch-request-list" component={WatchRequestList} />
      <Route exact={true} path="/administration/notification" component={NotificationComponent} />
      <Route exact={true} path="/SignUp" component={gfComponent} />
      <Route exact={true} path="/pricing" component={PricingContent} />
      <Route exact={true} path="/dealersubs" component={StepperComponent}></Route>
      {/* Comment on Jan 25 <Route exact={true} path="/subscription" component={chooseSubscription}></Route> */}
      {/*  Comment on Jan 25 <Route exact={true} path="/dealernew" component={NewStepperComponent}></Route> */}
      <Route exact={true} path="/dealerfeed/:name" component={dealerInventory}></Route>
      <Route exact={true} path="/verify-email" component={verifyEmailComponent} />
      <Route exact={true} path="/confirm-email" component={verificationEmail} />
      <Route exact={true} path="/email-verification" component={emailVerify} />
      <Route exact={true} path="/forgot-success" component={ForgetSuccessComponent} />
      <Route exact={true} path="/bussiness-detail" component={registerComponent} />
      {/* <Route
        exact={true}
        path="/forgot-password"
        component={ForgotPasswordComponent}
      />  */}
      <Route
        exact={true}
        path="/forgot-password"
        component={RecoveryPasswordComponent}
      />
      <Route
        exact={true}
        path="/shopifysuccess"
        component={ShopifySuccess}
      />
      <Route
        exact={true}
        path="/shopify-configuration"
        component={ShopifyConfigPage}
      />
      <Route
        exact={true}
        path="/ebaysuccess"
        component={EbaySuccess}
      />
      <Route
        exact={true}
        path="/qbosuccess"
        component={qboSuccess}
      />
      <Route
        exact={true}
        path="/appinstall"
        component={AppInstall}
      />
      <Route exact={true} path="/forgot-otp" component={OtpPasswordComponent} />
      <Route exact={true} path="/verify-otp" component={verifyOtpPasswordComponent} />
      <Route
        exact={true}
        path="/reset-password"
        component={resetPassword}
      />
      <Route
        exact={true}
        path="/set-password"
        component={setPasswordComponent}
      />
      <Route
        exact={true}
        path="/privacy-policy"
        component={PrivacyPolicyComponent}
      />
      <Route
        exact={true}
        path="/terms-conditions"
        component={TermsConditionComponent}
      />
      <Route
        exact={true}
        path="/service-agreement"
        component={ServiceAgreementComponent}
      />
      <Route
        exact={true}
        path="/faq"
        component={FAQComponent}
      />
      <Route
        exact={true}
        path="/giveaway"
        component={GiveAwayComponent}
      />
      <Route
        exact={true}
        path="/who-we-are"
        component={WhoAreMainPageComponent}
      />
      <Route
        exact={true}
        path="/inventory-transfer"
        component={inventoryTransfer}
      />
      <Route path='/' render={(props) => <Layout {...props} />} />
    </Switch>
  </MuiThemeProvider>
);


export default Routes;